import React from 'react';
import { MDBBtn } from 'mdb-react-ui-kit';
import ListIcon from '../assets/icons/edit-list-icon.svg';


const ShortlistRow = ({ shortlist, onRowClick, onDeleteClick }) => {
    return (
        <tr onClick={() => onRowClick(shortlist)} style={{ cursor: 'pointer' }}>
            <td className='d-flex align-items-center'>
                <div className='content-icon me-2'>
                    <img src={ListIcon} alt='list-icon' width={15} height={15} />
                </div>
                {shortlist.name}
            </td>
            <td>{shortlist.influencerIds ? shortlist.influencerIds.split(',').length : 0}</td>
            <td>{shortlist.username}</td>
            <td>
                <MDBBtn color='link' className='p-1 text-danger' onClick={(e) => { e.stopPropagation(); onDeleteClick(shortlist); }}>
                    Delete
                </MDBBtn>
            </td>
        </tr>
    );
};

export default ShortlistRow;
